export enum DependencyType {
    FATHER = 'FATHER',
    MOTHER = 'MOTHER',
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    SERVICE_PROVIDER = 'SERVICE_PROVIDER',
    OTHER = 'OTHER'
}